import angular from 'angular';

angular.module('myConsultApp').directive('statisticsBox', () => {
  const mapStateToScope = (state) => {
    return {
      statistics: state.organization?.activeOrganization?.statistics,
    };
  };

  return {
    restrict: 'E',
    transclude: true,
    templateUrl: './templates/statistics-box.html',
    controller: ($scope, $ngRedux) => {
      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope)($scope);
      };

      $scope.init();
      $scope.$on('$destroy', () => {
        $scope.unsubscribe();
      });
    },
  };
});
